/* istanbul ignore file */
import { EmployeeInput } from 'domain/shared/employee';

const MentorDropdown = (props: any) => {
  return (
    <EmployeeInput
      source="mentorshipInformation.mentor"
      nameSource="mentorshipInformation.mentorName"
      label="Mentor"
      placeholder="Select a mentor"
      {...props}
    />
  );
};

export default MentorDropdown;
